import { Component } from '@angular/core';

@Component({
    selector: 'app-warning-icon',
    templateUrl: './warning-icon.component.html',
    styleUrls: ['./warning-icon.component.scss'],
    standalone: false
})
export class WarningIconComponent {

}
